import { sortOptionsISelect } from "../helpers/sortISelect";
import { Gender } from "../model/enumerations/gender.model";
import { ISelect } from "../model/iSelect";

export const genderEnum = (): Array<ISelect> => {
  const gender: Array<ISelect> = [
    {
      label: `Femenino`,
      value: Gender.FEMALE,
    },
    {
      label: `Masculino`,
      value: Gender.MALE,
    },
    {
      label: `LGBTIQ+`,
      value: Gender.LGBTIQ,
    },
    {
      label: `No binario`,
      value: Gender.NON_BYNARY,
    },
    {
      label: `Otro`,
      value: Gender.OTHERS,
    },
  ];
  return sortOptionsISelect(gender);
};
